import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuthStore } from '@repo/api-client'
import Sidebar from '@repo/ui/Sidebar/Sidebar'
import LanguageSwitcher from '@repo/ui/LanguageSwitcher'
import { Box } from '@mui/material'
import { menuConfig, MENU_KEYS } from './config/configMenu'
import { type Role } from './config/constants'


const Layout = () => {
  const user = useAuthStore((state) => state.user)
  const logout = useAuthStore((state) => state.logout)
  const location = useLocation()

  if (!user) {
    // Redirect to the login page (path '/') if the user is not authenticated
    return <Navigate to='/' replace />
  }

  const noMenuPaths = ['/fast-signup/generate-qr']
  const showMenu = !noMenuPaths.some((path) =>
    location.pathname.startsWith(path),
  )

  if (!showMenu) {
    return (
      <div className='min-h-screen bg-slate-50 text-slate-800 overflow-x-hidden w-full relative'>
        <Outlet />
        <Box
          sx={{
            position: 'fixed',
            bottom: { xs: 100, sm: 20 },
            left: 0,
            zIndex: 9999,
          }}
        >
          <LanguageSwitcher
            sx={{
              bgcolor: 'white',
              border: '1px solid rgba(0,0,0,0.1)',
              boxShadow: 3,
            }}
          />
        </Box>
      </div>
    )
  }

  return (
    <div className='flex min-h-screen bg-slate-100'>
      <Sidebar<MENU_KEYS, Role>
        menuConfig={menuConfig}
        user={user}
        logout={logout}
        currentApp="auth"
      />
      {/* Main Content */}
      <div className='flex-grow bg-slate-50 text-slate-800 overflow-x-hidden min-h-screen'>
        <Outlet /> {/* This will render the current page */}
      </div>
    </div>
  )
}

export default Layout
